"use strict";
// Copyright (c) StrangeBee 2023
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const ParentController_1 = __importDefault(require("../ParentController"));
class SearchController extends ParentController_1.default {
    constructor() {
        super(...arguments);
        this.endpoints = {
            keyword: '/v1/search',
            count: '/v1/search/count',
        };
    }
    keyword(query) {
        return this.manager.post({
            url: this.endpoints.keyword,
        }, {
            query,
        });
    }
}
exports.default = SearchController;
